import { render, staticRenderFns } from "./searchIpfc.vue?vue&type=template&id=0650ba26"
import script from "./searchIpfc.vue?vue&type=script&lang=js"
export * from "./searchIpfc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports